import * as React from 'react';
import { Segment, Grid, Form, Header, Button } from 'semantic-grab-ui/src';
import formComponent from 'components/decorators/form_component';
import FormInputWithError from 'components/form/FormInputWithError';
import { CampaignFormProps, Campaign } from 'types/ts/campaigns';
import _ from 'lodash';
import './TreatmentForm.scss';
import './WidgetComponent.scss';
import Toastr from 'omega-rtc/utils/toastr-util';
import { nodeTypes } from 'data/trident-types';


type ExperimentFormState = {
  originalModel: Campaign,
  parentNode: string,
};

@formComponent()
export default class ExperimentForm extends React.Component<
  CampaignFormProps,
  ExperimentFormState
> {
  constructor(props) {
    super(props);
    this.state = {
      originalModel: this.props.model,
      parentNode: this.props.parentNode,
    };
  }

  cancelExperiment = () => {
    const { currentNode, isAdd, handleDeleteNode, onModelChange, handleCloseModal, model } = this.props;
    const { originalModel, parentNode } = this.state;
    if (isAdd) {
      // eslint-disable-next-line no-alert
      const confirmValue = confirm(
        'Cancel will delete this inactive node. Are you sure to delete this?',
      );
      if (!confirmValue) return;
      onModelChange(originalModel);
      handleDeleteNode(parentNode, currentNode, -1);
    } else {
      onModelChange(originalModel);
    }
    handleCloseModal();
  };

  saveExperiment = () => {
    const {parentKeyList, model} = this.props
    if (this.actionHasBeenTriggered(model, parentKeyList[0])) {
      Toastr.error('Adding or updating experiment node is not allowed if the action has been triggered');
      return
    }
    if (!this.props.isValid()) {
      Toastr.error('There are errors in experiment form.');
      return;
    }
    this.updateGroupIDs();
    this.props.handleCloseModal();
  };

  addTreatmentGroup = async () => {
    const { currentNode, model, onModelChange, handleAddNode, parentKeyList } = this.props;
    let updatedModel = _.cloneDeep(model);

    // Update the group percentages first
    let groupPercentage =
      _.get(updatedModel.nodes[currentNode], 'data.groupPercentage') || [];

    const children =
    _.get(updatedModel.nodes[currentNode], 'children') || [];
    const noControlGroup = children.length === 0;

    groupPercentage.push(0);
    _.set(
      updatedModel.nodes[currentNode],
      'data.groupPercentage',
      groupPercentage,
    );
    await onModelChange(updatedModel);

    if (noControlGroup) {
      // Add one control treatment group
      await handleAddNode('experimentTreatment', currentNode, parentKeyList, {
        groupID: 0,
      });
    }
    await handleAddNode('experimentTreatment', currentNode, parentKeyList, {
      groupID: groupPercentage.length,
    });
  };

  removeTreatmentGroup = index => {
    const { currentNode, model, onModelChange, handleDeleteNode } = this.props;
    const updatedModel = _.cloneDeep(model);

    // Update the group percentages first
    const groupPercentage =
      _.get(updatedModel.nodes[currentNode], 'data.groupPercentage') || [];
    groupPercentage.splice(index, 1);
    onModelChange(updatedModel);

    const children = _.get(updatedModel.nodes[currentNode], 'children') || [];
    handleDeleteNode(currentNode, children[index + 1], -1);
  };

  updateGroupIDs = () => {
    const { currentNode, model, onModelChange } = this.props;
    const updatedModel = _.cloneDeep(model);
    const children = _.get(updatedModel.nodes[currentNode], 'children') || [];

    for (let i = 0; i < children.length; i += 1) {
      updatedModel.nodes[children[i]].data.groupID = i;
    }
    onModelChange(updatedModel);
  };

  // Check whether the scenario or schedule action has been triggered
  actionHasBeenTriggered = (model, rootNodeId) => {
    const rootNode = _.get(model, `nodes.${rootNodeId}`);
    if (rootNode.type === nodeTypes.schedule) {
      return !_.isEmpty(rootNode.data.lastHappenedAt);
    } else  if (rootNode.type === nodeTypes.scenarios) {
      return _.get(model, `usage.scenarioUsages[${rootNodeId}].total`, 0) > 0;
    }
    return false;
  }

  render() {
    const { model, currentNode } = this.props;
    const groupPercentage =
      _.get(model.nodes[currentNode], 'data.groupPercentage') || [];
    const controlPercentage = 100 - _.sum(groupPercentage);

    return (
      <div>
        <div className="model-button">
          <Grid>
            <Grid.Column textAlign="right">
              <Button.Group>
                <Button onClick={this.cancelExperiment}>Cancel</Button>
                <Button.Or />
                <Button positive onClick={this.saveExperiment}>
                  Save
                </Button>
              </Button.Group>
            </Grid.Column>
          </Grid>
        </div>
        <div className="treatment-form">
          <Segment className="treatment-form-segment">
            <Grid>
              <Grid.Column width={12}>
                <Header as="h3">Groups percentage</Header>
              </Grid.Column>
            </Grid>
            <Grid>
              <Grid.Column width={6}>Control Group Percentage</Grid.Column>
              <Grid.Column width={4}>
                <FormInputWithError
                  name={`nodes.${currentNode}.data.groupPercentage`}
                  {...this.props}
                >
                  <Form.Input
                    type="number"
                    required
                    value={controlPercentage}
                    disabled
                  />
                </FormInputWithError>
              </Grid.Column>
            </Grid>
            {groupPercentage.map((percentage, index) => (
              <Grid key={`treatment${index}`}>
                <Grid.Column width={6}>
                  Treatment {index + 1} Group Percentage
                </Grid.Column>
                <Grid.Column width={6}>
                  <FormInputWithError
                    name={`nodes.${currentNode}.data.groupPercentage.${index}`}
                    {...this.props}
                  >
                    <Form.Input
                      type="number"
                      required
                      value={_.get(model.nodes[currentNode], `data.groupPercentage.${index}`)}
                      onChange={this.props.handleInputChange}
                      onBlur={this.props.handleControlBlur}
                    />
                  </FormInputWithError>
                </Grid.Column>
                <Grid.Column width={2}>
                  <Button onClick={() => this.removeTreatmentGroup(index)}>
                    Delete
                  </Button>
                </Grid.Column>
              </Grid>
            ))}
            <Button positive onClick={this.addTreatmentGroup}>
              Add treatment group
            </Button>
          </Segment>
        </div>
      </div>
    );
  }
}
